import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import { FiToggleSwitchSliderColorClass } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.component';

@Component({
    selector: 'fi-items-list-filter-header',
    template: `
        <div class="filter-visibility-toggle-container cursor-pointer" (click)="toggleFiltersVisibility()">
          <div class="filter-toggle">
            @if (!isFilterSettingsShown) {
              <mat-icon class="fas fa-sliders"></mat-icon>
            }
            @if (isFilterSettingsShown) {
              <span class="filter-toggle-close-icon"></span>
            }
            <span class="filter-toggle-label">{{ 'common.filter' | fiAppText }}</span>
            @if (!isFilterSettingsShown && !!selectedFilterItemsLength) {
              <div
                class="filter-summary-badge BrandedBackgroundColor"
                >
                {{ selectedFilterItemsLength }}
              </div>
            }
          </div>
        </div>
        @if (hasSuperAdminAccess) {
          <div class="filter-super-admin-container">
            <span class="filter-super-admin-icon BrandedColor far fa-shield-check"></span>
            <span class="filter-super-admin-label">{{ 'filter.super_admin_access' | fiAppText }}</span>
            <fi-toggle-switch
              [(value)]="isSuperAdminAccess"
              [switchSliderColorClass]="FiToggleSwitchSliderColorClass.Branded"
              [isSmallSwitchSize]="true"
              (valueChange)="onIsSuperAdminAccess($event)"
              />
              <fi-info-icon
                [mode]="FiInfoIconMode.WithoutIconAbsolute"
                [fiInfoPosition]="'right-under'"
                [tooltipClass]="'no-arrow'"
                [isIconTooltipShown]="false"
                >
                <span>{{ 'filter.super_admin_description' | fiAppText }}</span>
              </fi-info-icon>
            </div>
          }
        `,
    styleUrls: ['./fi-items-list-filter-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-items-list-filter-header' },
    standalone: false,
})
export class FiItemsListFilterHeaderComponent {
    @Input() selectedFilterItemsLength: number;
    @Input() hasSuperAdminAccess: boolean;
    @Input() isSuperAdminAccess: boolean;
    @Output() isSuperAdminAccessChange = new EventEmitter<boolean>();
    @Input() isFilterSettingsShown: boolean;
    @Output() isFilterSettingsShownChange = new EventEmitter<boolean>();

    FiInfoIconMode = FiInfoIconMode;

    toggleFiltersVisibility() {
        this.isFilterSettingsShown = !this.isFilterSettingsShown;
        this.isFilterSettingsShownChange.emit(this.isFilterSettingsShown);
    }

    onIsSuperAdminAccess($event: boolean) {
        this.isSuperAdminAccess = $event;
        this.isSuperAdminAccessChange.emit(this.isSuperAdminAccess);
    }

    protected readonly FiToggleSwitchSliderColorClass = FiToggleSwitchSliderColorClass;
}
